import React from "react";

const ButtonGroup = ({ children }: any): JSX.Element => {
  return (
    <div className="w-full gap-4 flex items-center justify-center">
      {children}
    </div>
  );
};
export default ButtonGroup;
